import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/downloadIcon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Container/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/homepage/GreyBackgroundInfoSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/FullImageSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/GreyBackgroundInfoProductSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/InstructionsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/ProductSpecificationListSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/ProductSpecificationSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/SoftwareArchive/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/SoftwareNew/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/TileWithImageCenterSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/TileWithImageDoubeText/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/TileWithImageProductSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/product/TitleProduct/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ProductPage/ProductPage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/views/Product/styles.module.scss");
